import { render } from "./confirmarPedido.vue?vue&type=template&id=2db5d2ba&scoped=true"
import script from "./confirmarPedido.vue?vue&type=script&lang=js"
export * from "./confirmarPedido.vue?vue&type=script&lang=js"

import "./confirmarPedido.vue?vue&type=style&index=0&id=2db5d2ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2db5d2ba"]])

export default __exports__